module.exports = require('./StaticInputCell');
